module.exports = require('./StaticInputCell');
